import * as React from "react";
import type { SVGProps } from "react";
const SvgTerminal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.293 16.293a1 1 0 1 0 1.414 1.414zM10 11l.707.707a1 1 0 0 0 0-1.414zM4.707 4.293a1 1 0 0 0-1.414 1.414zM12 18a1 1 0 1 0 0 2zm8 2a1 1 0 1 0 0-2zM4.707 17.707l6-6-1.414-1.414-6 6zm6-7.414-6-6-1.414 1.414 6 6zM12 20h8v-2h-8z"
    />
  </svg>
);
export default SvgTerminal;
